<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'股权融资管理'},{name:'股权融资项目列表'}]" :title="'股权融资项目列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">行业</span>
                        <el-select v-model="sendInfoOne.trade" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in industry"
                            :key="item.id"
                            :label="item.dictName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">轮次</span>
                        <el-select v-model="sendInfoOne.rounds" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in rounds"
                            :key="item.id"
                            :label="item.dictName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="项目ID">
                </el-table-column>
                <el-table-column
                    prop="projectName"
                    show-overflow-tooltip
                    
                    label="项目名称">
                </el-table-column>
                <el-table-column
                    prop="tradeValue"
                    show-overflow-tooltip
                    
                    label="行业">
                </el-table-column>
                <el-table-column
                    prop="roundsValue"
                    show-overflow-tooltip
                    
                    label="轮次">
                </el-table-column>
                <el-table-column
                    prop="interviewNum"
                    show-overflow-tooltip
                    
                    label="约谈数">
                </el-table-column>
                <el-table-column
                    prop="agencyNum"
                    show-overflow-tooltip
                    
                    label="推荐机构数">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="views"
                    show-overflow-tooltip
                    
                    label="浏览数">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:equity:finance:project:list:button:view') != -1 ||
                        authorities.indexOf('sys:permission:background:equity:finance:project:list:button:status') != -1 ||
                        authorities.indexOf('sys:permission:background:equity:finance:project:list:button:recommend') != -1"
                    label="操作"
                    
                    width="280">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:equity:finance:project:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
                        <el-button size="small" :type="scope.row.btnValue === '上架'?'success':'warning'" class="super" plain :disabled="scope.row.isEditable == 1"  v-if="authorities.indexOf('sys:permission:background:equity:finance:project:list:button:status') != -1 " @click="soldOut(scope.row)">{{scope.row.btnValue}}</el-button>
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:equity:finance:project:list:button:recommend') != -1" @click="recommend(scope.row)">推荐机构</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref='pagination'>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 审核 -->
            <el-dialog
                title="推荐机构"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>机构名称：</div>
                        <div class="content"><el-input v-model="sendInfoTwo.agencyName"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.agencyName']">错误提示：{{errors['sendInfoTwo.agencyName']}}</div>
                    <div class="childTextarea">
                        <div class="name"><span>*</span>进展说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.progressStatement" show-word-limit maxlength="200"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.progressStatement']">错误提示：{{errors['sendInfoTwo.progressStatement']}}</div>
                    <div class="doubleBtn">
                        <el-button  size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import timeMixins from "@/mixins/timeFormat";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			rounds:[],//轮次
			industry:[],//行业
            options: [{
                value: '2',
                label: '项目名称'
                }, {
                value: '3',
                label: '发布账号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                checkStatus:'',//审核状态
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                rounds:'',//轮次
                trade:'',//行业
                userName:'',//发布账号
                status:'',//上架状态
                projectName:'',//项目名称
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[{name:'ads'}],//表格数据
            currentPage:1,//当前页
            dialogAudit:false,//审核弹出层
            sendInfoTwo:{
                equityId:'',
                id:'',
                agencyName:'',//机构名称
                progressStatement :'',//进展说明
            },//审核提交数据
            scopeList:[],
            statusList:[],//上下架
            totalSize:null
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.agencyName':{
            test:function(){
                if(this.sendInfoTwo.agencyName){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写机构名称'
        },
        'sendInfoTwo.progressStatement':{
            test:function(){
                if(this.sendInfoTwo.progressStatement){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写进展说明'
        },
    },
    methods:{
      onReset(){
        const param = {
          currentPage:1,//当前页
                pageSize:10,//页条数
                checkStatus:'',//审核状态
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                rounds:'',//轮次
                trade:'',//行业
                userName:'',//发布账号
                status:'',//上架状态
                projectName:'',//项目名称
                property:null,//排序字段
                direction:null,//排序方式
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,param)
        this.getSelect = void 0
        this.dateS = []
        this.getValue = void 0
        this.getData()

      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/equityManagement/productDetail',query:{id:row.id,index:'/equityManagement/productList'}})
        },
        getList(id,btnValue){
            this.$axiosc.put('backstage/equity/financing/shelfObtained/'+id).then(res=>{
                if(res.code == 200){
                    this.getData()
                    this.$message({
                        type: 'success',
                        message:btnValue+'成功!'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        },
        //表格下架,上架按钮
        soldOut:function(row){
            let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.getList(row.id,btnValue)
                }).catch(() => {    
            });
        },
        //表格推荐机构按钮
        recommend:function(row){
            this.sendInfoTwo.equityId = row.id
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
			this.sendInfoTwo.progressStatement=null;
			this.sendInfoTwo.agencyName=null;
            this.dialogAudit=false
			this.$vuerify.clear();
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axioscBody.post('backstage/equity/financing/saveAgency',this.sendInfoTwo).then(res=>{
                    if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: '提交成功'
                        });
						this.cancel()
						// 刷新数据
						this.sendInfoOne.currentPage = 1;
						this.getData()
                        // this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message:res.msg
                        });
                    }
                })
            }
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getDic(){
            this.$axiosz.get('backstage/sysDict/UA_LS').then((r)=>{ //上下架
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
			// 行业
			this.$axiosz.get('/rpc/sysDict/parentId/1069409825193984').then(res=>{
			    if(res.code==200){
					this.industry=res.data
			    }else{
			        this.$alert(res.msg)
			    }
			})
			// 轮次
			this.$axiosz.get('/rpc/sysDict/parentId/1069409841971200').then(res=>{
			    if(res.code==200){
					this.rounds=res.data
			    }else{
			        this.$alert(res.msg)
			    }
			})
			
        },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id = ''
            this.sendInfoOne.projectName = ''
            this.sendInfoOne.userName = ''
            if(this.getSelect=='1'){ //项目ID
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //项目名称
                this.sendInfoOne.projectName=this.getValue;
            }else if(this.getSelect=='3'){ //发布账号
                this.sendInfoOne.userName=this.getValue;
            }
            this.$axiosc.get('backstage/equity/financing/allList',{params:this.sendInfoOne}).then((r)=>{
                this.loading = false
                if(r.code==200){
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                }else{
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },
    mounted(){
        const that = this
        that.getDic();
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>